module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.3/frontend/_next/static/images/rectangle-3-fdfe780f14c8abc4486e38fe9eb0587e.png";